import React from "react";
import Faqs from "../components/faqs/faqs";
import withTracker from "./withtracker";
import AuthorizationHOC from "./AuthorizationHOC";
import { ALL_USERS } from "../constants/userGroups";
import withBreadCrumb from "./withBreadcrumb";
import useFaqs from "../customHooks/useFaqs";
import FaSpinner from "@/components/faSpinner/faSpinner";

const FaqsHOC = () => {
  const {
    faqs,
    faqsIds,
    faqsCategory,
    faqsCategoryIds,
    search,
    searchFaqText,
  } = useFaqs();

  if (!faqs || faqs.length === 0) {
    return (
      <div>
        <FaSpinner loading />
      </div>
    );
  }

  return (
    <Faqs
      faqs={faqs}
      faqsIds={faqsIds}
      faqsCategory={faqsCategory}
      faqsCategoryIds={faqsCategoryIds}
      search={search}
      searchFaqText={searchFaqText}
    />
  );
};

export default withTracker(
  AuthorizationHOC(ALL_USERS)(
    withBreadCrumb(FaqsHOC, {
      name: "FAQs",
      className: "faq-area",
    })
  )
);
